import { writable } from "svelte/store";
const customResults = writable([]);
export const resultsBoule = {
    subscribe: customResults.subscribe,
    addResult: (result) => {
        const newResult = Object.assign(Object.assign({}, result), { id: Math.random().toString() });
        customResults.update(r => {
            return [newResult, ...r];
        });
    }
};
